import {
  AfterContentInit,
  Component,
  ElementRef,
  HostBinding,
  HostListener,
  OnChanges,
  OnDestroy,
  OnInit,
  SimpleChanges,
  ViewEncapsulation,
  inject,
  input,
  viewChild,
  WritableSignal,
  signal,
  Signal,
  computed,
} from '@angular/core';
import {
  PlatformIdService,
  RenderHtml,
  Translation,
  TranslationTextNameType,
} from '@ckmk/angular';
import { environment } from '@app/src/environments/environment';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';

@Component({
  selector: 'front-header',
  standalone: true,
  imports: [Translation, RenderHtml],
  templateUrl: './front-header.html',
  styleUrl: './front-header.scss',
  host: {
    '[class.use-sticky-header]': 'sticky()',
    '[style.background-image]': 'localBackgroundUrl()',
    '(window:scroll)': 'onContainerScroll($event)',
  },
  encapsulation: ViewEncapsulation.None,
})
export class FrontHeader
  implements OnInit, OnChanges, OnDestroy, AfterContentInit
{
  protected readonly self = inject<ElementRef<HTMLElement>>(ElementRef);

  protected readonly router = inject(Router);

  protected readonly platform = inject(PlatformIdService);

  public readonly backgroundUrl = input<string>();

  public readonly content = input<TranslationTextNameType>();

  public readonly description = input<TranslationTextNameType>();

  public readonly sticky = input<boolean>(true);

  protected readonly coreContent =
    viewChild.required<ElementRef<HTMLDivElement>>('core_content');

  protected readonly titleContent =
    viewChild.required<ElementRef<HTMLDivElement>>('title_content');

  protected readonly subscriptions: WritableSignal<Subscription[]> = signal<
    Subscription[]
  >([]);

  protected readonly localBackgroundUrl: Signal<string> = computed<string>(
    () => {
      const backgroundUrl = this.backgroundUrl();

      if (backgroundUrl) {
        return `url("${backgroundUrl}")`;
      } else if (backgroundUrl === undefined) {
        return 'url("/img/front-header.jpg")';
      }

      return '';
    },
  );

  protected readonly localTitle: Signal<TranslationTextNameType> =
    computed<TranslationTextNameType>(() => {
      const content = this.content();
      if (content) {
        return content;
      }

      return environment.SITE_NAME;
    });

  public constructor() {}

  public ngOnInit() {}

  public ngOnChanges({}: SimpleChanges) {}

  public ngOnDestroy() {
    this.subscriptions.update((list) =>
      list.filter((sub) => sub.unsubscribe()),
    );
  }

  public ngAfterContentInit() {}

  protected onContainerScroll(event: Event): void {
    if (this.sticky()) {
      // Get container height
      const containerHeight =
        this.self.nativeElement.getBoundingClientRect().height;

      // Get title height
      const titleHeight =
        this.titleContent().nativeElement.getBoundingClientRect().height;

      // Set top height
      const top = (containerHeight - titleHeight - 30).toString() + 'px';

      // Old top
      const oldTop = this.self.nativeElement.style.getPropertyValue(
        '--front-header-top-by-height',
      );

      if (top !== oldTop) {
        this.self.nativeElement.style.setProperty(
          '--front-header-top-by-height',
          top,
        );
      }
    }
  }
}
